import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import Link from '../../Link';
import s from './ThemeThumb.css';
import getUser, { isAdmin } from '../../../utils/getUser';
import { reScreenshot } from '../../../data/fetch/reScreenshot';

const styles = {
	media: {
		height: 147,
	},
	content: {
		margin: 10,
	},
	installs: {
		textAlign: 'right',
	},
};

function ThemeLink({ id, children }) {
	return (
		<Link to={`/theme/${id}`} className={s.link}>
			{children}
		</Link>
	);
}

ThemeLink.propTypes = {
	id: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
};

export default function ThemeThumb({ theme }) {
	useStyles(s);
	const user = getUser();
	const [loadingReScreenshot, setLoadingReScreenshot] = React.useState(false);
	const admin = isAdmin(user);

	async function screenshot() {
		setLoadingReScreenshot(true);
		await reScreenshot(theme.id);
		setLoadingReScreenshot(false);
	}

	return (
		<div className={s.card}>
			<ThemeLink id={theme.id}>
				<div
					className={s.media}
					style={{
						...styles.media,
						backgroundImage: `url(/screenshots/400/${theme.id}-${theme.workspace}.jpg)`,
					}}
				/>
			</ThemeLink>

			<div style={styles.content}>
				<ThemeLink id={theme.id}>
					<span className={s.title}>
						{theme.madeWith === '4.0' && (
							<span
								className={s.badge}
								title="Made in New Tab Studio 4.0"
							>
								4.0
							</span>
						)}
						{theme.title}
					</span>
				</ThemeLink>

				<div style={styles.installs}>
					{admin && !loadingReScreenshot && (
						<Button
							color="primary"
							size="small"
							onClick={screenshot}
						>
							Re-screenshot
						</Button>
					)}

					{loadingReScreenshot && <CircularProgress size={20} />}

					<Button
						color="secondary"
						size="small"
						onClick={e => {
							e.stopPropagation();
							e.preventDefault();
							window.open(`/demo/xdr${theme.id}`, '_blank');
						}}
					>
						Demo
					</Button>

					<ThemeLink id={theme.id}>
						<Button color="primary" size="small">
							Details
						</Button>
					</ThemeLink>

					{/* <GetAppIcon/> {theme.installs} */}
				</div>
			</div>
		</div>
	);
}

ThemeThumb.propTypes = {
	theme: PropTypes.shape({
		id: PropTypes.string.isRequired,
		title: PropTypes.string,
		workspace: PropTypes.number,
		madeWith: PropTypes.string,
	}).isRequired,
};
